export default __webpack_public_path__ + "static/media/me10.a2eab5d7.gif";